import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { Button, Menu } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import * as React from "react";
import { DataGridContext } from "../../../context/DataGridContext";
export default function PricingFilterPricebands() {
	const {
		data,

		priceBandFilterValue,
		setPriceBandFilterValue,
	} = React.useContext(DataGridContext);

	const priceBandFilterData = data.priceband.filter(
		(priceband) => priceband.priceband_details.isActive
	);
	const [isUpdating, setIsUpdating] = React.useState(false);
	const [anchorEl, setAnchorEl] = React.useState(null);
	const open = Boolean(anchorEl);
	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};


	const [checked, setChecked] = React.useState(true);

// console.log('here', priceBandFilterValue, priceBandFilterData)

	React.useEffect(() => {
		if(checked) {
		setPriceBandFilterValue(['1', ...priceBandFilterData.map((pb) => pb.priceband_number)]);
		} else {
		setPriceBandFilterValue(['1']);	
		}
	}, [checked]);


	React.useEffect(() => {
		if (isUpdating) {
			setIsUpdating(false);
		}
	}, [isUpdating]);

	const handlePriceBandChange = (number) => {
		
		let val = [...priceBandFilterValue];

		if (val.includes(number)) {
			val = priceBandFilterValue.filter((i) => i !== number);
		} else {
			val.push(number);
		}
		setIsUpdating(true);
		setPriceBandFilterValue(
			val
		);
	};
	if (priceBandFilterData.length > 1) {
		return (
			<div>
				<Button
					id="basic-button"
					aria-controls={open ? "basic-menu" : undefined}
					aria-haspopup="true"
					aria-expanded={open ? "true" : undefined}
					onClick={handleClick}
				>
					Pricebands
					<FilterAltIcon />
				</Button>
				<Menu
					id="basic-menu"
					anchorEl={anchorEl}
					open={open}
					onClose={handleClose}
					MenuListProps={{
						"aria-labelledby": "basic-button",
					}}
				>
					<MenuItem
							key={'check'}
							value={checked}
							onClick={() => setChecked(!checked)}
						>
							<Checkbox checked={checked} />
							<ListItemText primary={checked ? 'Unselect all' : 'Select All'} />
						</MenuItem>
					{priceBandFilterData.map((priceband) => (
						<MenuItem
							key={priceband.priceband_name}
							value={priceband.priceband_number}
							onClick={(event) =>
								handlePriceBandChange(priceband.priceband_number)
							}
						>
							<Checkbox
								checked={
									priceBandFilterValue.indexOf(priceband.priceband_number) > -1
								}
							/>
							<ListItemText primary={priceband.priceband_name} />
						</MenuItem>
					))}
				</Menu>
			</div>
		);
	}
}
